<template>
  <div>
    <PageTitle>
      <b-container>
        <h1 class="display-3">Project List</h1>
        <p class="lead">
          Select a project below to go to its project page.<br />
        </p>
        <b-button
          variant="primary"
          href="/SINSW CBA Tool Input Template.xlsm"
          download
        >
          Download inputs template
        </b-button>
      </b-container>
    </PageTitle>
    <b-overlay :show="loading" rounded="sm" no-wrap fixed />
    <b-container>
      <b-row>
        <b-col class="text-right">
          <b-button variant="primary" :href="`/project/create`">
            Create a project
          </b-button>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col cols="4">
          <b-card no-body>
            <template v-slot:header>
              <b-card-title
                class="d-flex justify-content-between align-items-center"
              >
                Global inputs
              </b-card-title>
            </template>
            <b-card-body>
              <b-card-text>
                <b-button @click="gotoParameterList" block variant="primary">
                  View global parameters
                </b-button>
              </b-card-text>
              <b-card-text>
                <b-button
                  @click="gotoEnrolmentProjection"
                  block
                  variant="primary"
                >
                  View enrolment projections
                </b-button>
              </b-card-text>
              <b-card-text>
                <b-button @click="gotoSchoolList" block variant="primary">
                  View schools
                </b-button>
              </b-card-text>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col>
          <Table
            :filter_toggle="true"
            :fields="fields"
            :items="items"
            :selectable="selectMultiple"
            @filter="onFilter"
            @deleteObject="deleteProject($event)"
          >
          </Table>
          <!-- <b-card no-body>
            <template v-slot:header>
              <b-card-title
                class="d-flex justify-content-between align-items-center"
              >
                Projects
              </b-card-title>
            </template>
          </b-card> -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import Table from "@/components/Table.vue";

export default {
  name: "ProjectList",
  components: { PageTitle, Table },
  methods: {
    gotoEnrolmentProjection() {
      this.$router.push({ name: "EnrolmentProjectionList" });
    },
    gotoSchoolList() {
      this.$router.push({ name: "SchoolList" });
    },
    gotoParameterList() {
      this.$router.push({ name: "ParameterList" });
    },
    onFilter(event) {
      this.filteredItems = event;
    },
    getProjects() {
      this.$store
        .dispatch("get", {
          url: "/project",
        })
        .then((response) => {
          this.loading = false;
          this.items = response.data.items;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteProject(event) {
      // event.preventDefault();
      this.loaded = false;
      this.$store
        .dispatch("delete", {
          url: "/project/" + event.selected_id,
        })
        .then(() => {
          this.items.splice(
            this.items.findIndex(
              (item) => item.public_id === event.selected_id
            ),
            1
          );
        })
        .catch((error) => {
          if (!error.response) {
            console.log("There was a problem in the server.");
          }
          console.log(error.response.data);
          alert(error.response.data);
        })
        .finally(() => {
          this.loaded = true;
        });
    },
  },
  data() {
    return {
      fields: [
        {
          key: "project_id",
          label: "Project ID",
          sortable: true,
        },
        {
          key: "project_name",
          label: "Project Name",
          sortable: true,
        },
        {
          key: "school_name",
          label: "School Name",
          sortable: true,
        },
        {
          key: "school_scg",
          label: "SCG",
          sortable: true,
        },
        {
          key: "public_id",
          sortable: false,
        },
      ],
      items: [
        // {
        //   project_id: "20220001",
        //   project_name: "Project 1",
        //   school_name: "School 1",
        //   school_scg: "SCG 1",
        //   public_id: "20220001",
        // },
        // {
        //   project_id: "20220002",
        //   project_name: "Project 2",
        //   school_name: "School 2",
        //   school_scg: "SCG 2",
        //   public_id: "20220002",
        // },
      ],
      filteredItems: [],
      selectMultiple: false,
      show: false,
    };
  },
  mounted() {
    this.getProjects();
    console.log(this.isAdmin);
    if (!this.isAdmin) {
      this.$router.push({ name: "logout" });
    }
  },
  created() {},
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
};
</script>

<style scoped>
.jumbotron {
  padding: 1em 0.5em;
}
</style>
